import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationExtras,
  Params,
} from '@angular/router';

import * as HttpStatus from 'http-status-codes';
import * as $ from 'jquery';

import { UsersService } from '../../services/users.service';

import { Helper } from '../../helper';

const _ = require('underscore');

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  API = this.helper.getApi();
  notification = { message: '', type: '' };
  preselectedClinic: string;
  superClinicId: string;
  service: string;
  type: string;
  singleClinic: string;
  recoverType = 'email';
  showPhone = false;
  phone = '';
  data = {
    cpr: { validate: true, value: '' },
    email: { validate: false, value: '' },
    phone: { validate: false, value: '' },
  };
  emailFormValid = false;
  smsFormValid = false;
  showError = false;

  constructor(
    public helper: Helper,
    public usersService: UsersService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.preselectedClinic = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.type = params.type;
      this.singleClinic = params.singleClinic;
    });
  }

  selectType(element) {
    if (element.target.value === 'sms') {
      this.recoverType = 'sms';
    } else {
      this.recoverType = 'email';
    }
  }

  handleInput(element) {
    const target = element.target;
    const input = this.data[target.name];

    if (target.name === 'cpr') {
      // CPR validation
      target.value = target.value.replace(/[^\d]/, '');

      if (target.value.length > 10) {
        target.value = target.value.substr(0, 10);
      }

      if (this.helper.validateCpr(target.value)) {
        input.validate = true;
      } else {
        input.validate = false;
      }
    } else {
      if (this.validateField(target.value, target.pattern)) {
        input.validate = true;
      } else {
        input.validate = false;
      }
    }

    input.value = target.value;

    if (this.recoverType === 'email') {
      let email = this.data.email,
        cpr = this.data.cpr;

      if (email.validate && cpr.validate) {
        this.emailFormValid = true;
      } else {
        this.emailFormValid = false;
      }
    }

    if (this.recoverType === 'sms') {
      let phone = this.data.phone,
        cpr = this.data.cpr;

      if (phone.validate && cpr.validate) {
        this.smsFormValid = true;
      } else {
        this.smsFormValid = false;
      }
    }
  }

  validateField(value, pattern) {
    if (new RegExp(pattern).test(value)) {
      return true;
    } else {
      return false;
    }
  }

  sendForgotPassword() {
    let data = {
      flow_url: window.location.search.replace('?', '&'),
      cpr: $('#cpr').val(),
    };

    if (this.recoverType === 'email') {
      data['email'] = $('#email').val();
    } else {
      data['mobile'] = $('#phone').val();
    }

    this.usersService.forgotPassword(data).subscribe(
      (forgotResponse: any) => {
        this.handleSuccess(forgotResponse);
      },
      (forgotError) => {
        this.notification = {
          message:
            'Vi kan se at dit CPR nr. ikke matcher din email/dit mobilnr. Check venligst at indtastningen er korrekt eller kontakt den FysioDanmark-klinik, som du ønsker at registere ved for at få opdateret dine oplysninger.',
          type: 'error',
        };
      }
    );
  }

  handleSuccess(forgotResponse) {
    if (forgotResponse.status === HttpStatus.OK) {
      this.notification = {
        message: 'E-mail eller SMS er blevet sendt ud!',
        type: 'success',
      };

      const params = {
        type: this.type,
        service: this.service,
        singleClinic: this.singleClinic,
      };

      // if superclinic and superclinic + service flow, send params to next page
      if (this.superClinicId) {
        params['superClinicId'] = this.superClinicId;
      }

      // if singleclinic flow, send clinics params to next page
      if (this.singleClinic === 'true') {
        params['clinics'] = this.preselectedClinic;
      }

      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      setTimeout(() => {
        this.router.navigate(['/login'], navigationExtras);
      }, 1500);
    } else {
      this.notification = {
        message:
          'Vi kan se at dit CPR nr. ikke matcher din email/dit mobilnr. Check venligst at indtastningen er korrekt eller kontakt den FysioDanmark-klinik, som du ønsker at registere ved for at få opdateret dine oplysninger.',
        type: 'error',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forgot-password/forgot-password.component.ts